import { OrderedMap, List, Map as ImmutableMap } from 'immutable';
import { COLOR, colors } from '../constants/colors';
import { stepGradientColorsArray } from './interpolate';
export const THEME = {
  MULTI: 'multi',
  ORANGES: 'oranges',
  AQUAS: 'aquas',
  PURPLES: 'purples',
  YELLOWS: 'yellows',
  PINKS: 'pinks',
  BLUES: 'blues',
  GREENS: 'greens',
  FUNNEL: 'funnel',
  PATTERNS: 'patterns',
  BRAND_KIT: 'BrandKit'
};
export const themes = OrderedMap({
  [THEME.MULTI]: List([colors.get(COLOR.ORANGE), colors.get(COLOR.AQUA), colors.get(COLOR.PURPLE), colors.get(COLOR.YELLOW), colors.get(COLOR.PINK), colors.get(COLOR.BLUE), colors.get(COLOR.GREEN), colors.get(COLOR.DARK_ORANGE), colors.get(COLOR.DARK_AQUA), colors.get(COLOR.DARK_PURPLE), colors.get(COLOR.DARK_YELLOW), colors.get(COLOR.DARK_PINK), colors.get(COLOR.DARK_BLUE), colors.get(COLOR.DARK_GREEN)]),
  [THEME.ORANGES]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#fffbe6'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#e78f7b'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#904233'
  } // last
  ])),
  [THEME.AQUAS]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#a7ffff'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#329999'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#003333'
  } // last
  ])),
  [THEME.PURPLES]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#fdf2ff'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#9f70d5'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#3f00ab'
  } // last
  ])),
  [THEME.YELLOWS]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#fff1da'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#ffc25c'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#e68900'
  } // last
  ])),
  [THEME.PINKS]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#ffe4ff'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#d46f99'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#a80033'
  } // last
  ])),
  [THEME.BLUES]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#c7ffff'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#4799d7'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#0033af'
  } // last
  ])),
  [THEME.GREENS]: List(stepGradientColorsArray(9, [{
    positionFraction: 0,
    value: '#dbffc7'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#639947'
  },
  // middle (index 4)
  {
    positionFraction: 1,
    value: '#003300'
  } // last
  ])),
  [THEME.FUNNEL]: List(stepGradientColorsArray(10, [{
    positionFraction: 0,
    value: '#9784c2'
  },
  // first
  {
    positionFraction: 0.5,
    value: '#e093b6'
  },
  // middle (index 4.5)
  {
    positionFraction: 1,
    value: '#fea58e'
  } // last
  ])),
  [THEME.PATTERNS]: ImmutableMap({
    colorsTheme: THEME.MULTI,
    patterns: List([
    //Pulled from Highcharts' default patterns: https://github.com/highcharts/highcharts/blob/c11ce666605334e6ad245a8041f387f6e0fc3f87/ts/Extensions/PatternFill.ts#L99-L121
    'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9',
    // Line: /
    'M 0 0 L 5 10 L 10 0',
    //ZigZag Horizontal
    'M 3 3 L 8 3 L 8 8 L 3 8 Z',
    // Squares
    'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
    // Line: \
    'M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0' // Circles
    ]),
    dashStylePatterns: List(['Solid', 'ShortDash', 'ShortDot', 'ShortDashDot', 'ShortDashDotDot', 'Dot', 'Dash', 'LongDash', 'DashDot', 'LongDashDot', 'LongDashDotDot'])
  })
});